export default "__VITE_ASSET__d695fc6a__"